"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var colors_1 = require("../../constants/colors");
var classnames_1 = __importDefault(require("classnames"));
var AXSPrice_1 = __importDefault(require("../AXSPrice"));
var utils_1 = require("../../utils");
var PriceLevelWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-color: ", ";\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 6px;\n  cursor: ", ";\n  margin: 8px;\n  opacity: ", ";\n  padding: 8px;\n  width: 100%;\n  height: 64px;\n"], ["\n  border-color: ",
    ";\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 6px;\n  cursor: ", ";\n  margin: 8px;\n  opacity: ", ";\n  padding: 8px;\n  width: 100%;\n  height: 64px;\n"])), function (_a) {
    var active = _a.active, activeBorderColor = _a.activeBorderColor, borderColor = _a.borderColor, theme = _a.theme;
    return active
        ? utils_1.parseThemePath(activeBorderColor, theme, colors_1.colors.BLUE_300)
        : utils_1.parseThemePath(borderColor, theme, colors_1.colors.GREY_350);
}, function (_a) {
    var disabled = _a.disabled, readOnly = _a.readOnly;
    return disabled || readOnly ? 'default' : 'pointer';
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? '.3' : '1';
});
var PriceLevel = styled_components_1.default(AXSFlex_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n"], ["\n\n"])));
var PriceLevelLabel = styled_components_1.default(AXSFlexItem_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 15px;\n  margin-right: 16px;\n"], ["\n  color: ", ";\n  font-size: 15px;\n  margin-right: 16px;\n"])), function (_a) {
    var labelColor = _a.labelColor, theme = _a.theme;
    return utils_1.parseThemePath(labelColor, theme, colors_1.colors.GREY_650);
});
var PriceWrapper = styled_components_1.default(AXSFlexItem_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  white-space: nowrap;\n"])), function (_a) {
    var priceColor = _a.priceColor, theme = _a.theme;
    return utils_1.parseThemePath(priceColor, theme, colors_1.colors.BLUE_300);
});
var Price = styled_components_1.default(AXSPrice_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 20px;\n"], ["\n  font-size: 20px;\n"])));
var Available = styled_components_1.default(AXSBlock_1.default)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 11px;\n  font-weight: bold;\n  text-align: right;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  font-size: 11px;\n  font-weight: bold;\n  text-align: right;\n  text-transform: uppercase;\n"])), function (_a) {
    var ticketCountColor = _a.ticketCountColor, theme = _a.theme;
    return utils_1.parseThemePath(ticketCountColor, theme, colors_1.colors.GREY_650);
});
var AXSPriceLevelSelector = function (_a) {
    var active = _a.active, disabled = _a.disabled, id = _a.id, price = _a.price, priceHigh = _a.priceHigh, label = _a.label, labelColor = _a.labelColor, hideFrom = _a.hideFrom, borderColor = _a.borderColor, activeBorderColor = _a.activeBorderColor, togglePriceLevel = _a.togglePriceLevel, ticketCount = _a.ticketCount, ticketCountColor = _a.ticketCountColor, priceColor = _a.priceColor, readOnly = _a.readOnly, className = _a.className;
    return (React.createElement(PriceLevelWrapper, { active: active, activeBorderColor: activeBorderColor, borderColor: borderColor, className: classnames_1.default(['c-axs-price-level-selector', className]), disabled: disabled, readOnly: readOnly },
        React.createElement(PriceLevel, { onClick: function () { return !disabled || !readOnly ? togglePriceLevel(id) : null; }, alignItems: "center", marginBottom: "16px", key: id },
            React.createElement(PriceLevelLabel, { labelColor: labelColor }, label),
            React.createElement(PriceWrapper, { priceColor: priceColor, marginLeft: "auto" },
                React.createElement(AXSFlex_1.default, { alignItems: "center" },
                    !hideFrom && !priceHigh &&
                        React.createElement(AXSBlock_1.default, { fontSize: "15px", marginRight: "8px", inline: true }, "from"),
                    price !== priceHigh ?
                        React.createElement(AXSFlexItem_1.default, null, priceHigh ?
                            React.createElement(AXSFlex_1.default, null,
                                React.createElement(Price, { currency: "$", price: price.toString() }),
                                React.createElement(AXSBlock_1.default, { margin: "0 5px", fontSize: "20px" }, "-"),
                                React.createElement(Price, { currency: "$", price: priceHigh.toString() }))
                            :
                                React.createElement(Price, { currency: "$", price: price })) :
                        React.createElement(AXSFlexItem_1.default, null,
                            React.createElement(Price, { currency: "$", price: price }))),
                React.createElement(Available, { ticketCountColor: ticketCountColor },
                    ticketCount,
                    " available")))));
};
AXSPriceLevelSelector.defaultProps = {
    active: false,
    activeBorderColor: 'axsui.components.priceLevelSelector.activeBorderColor',
    borderColor: 'axsui.components.priceLevelSelector.borderColor',
    borderRadius: '6px',
    borderWidth: '2px',
    disabled: false,
    labelColor: 'axsui.components.priceLevelSelector.labelColor',
    priceColor: 'axsui.components.priceLevelSelector.priceColor',
    ticketCountColor: 'axsui.components.priceLevelSelector.ticketCountColor',
};
exports.default = AXSPriceLevelSelector;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map